import { render, staticRenderFns } from "./NotificationNewsIcon.vue?vue&type=template&id=da241ef8"
import script from "./NotificationNewsIcon.vue?vue&type=script&lang=js"
export * from "./NotificationNewsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports